import { memo } from 'react';
import { useSelector } from 'react-redux';

import { PencilIcon } from '@air/design-icons';
import {
  contentCollectionApplyAllSelector,
  contentCollectionFormSelector,
} from '@air/feature-content-collection/redux';
import { Button } from '@air/primitive-button';
import { IconButton } from '@air/primitive-icon-button';
import { useBreakpointsContext } from '@air/provider-media-query';
import { useAirModal } from '@air/provider-modal';
import { hasSelectedItemsSelector } from '@air/redux-selected-items';

import { ContentCollectionGalleryAssetDetailsModal } from '~/components/ContentCollection/ContentCollectionGalleryAssetDetailsModal';
import { selectedClipsSelector } from '~/store/selectedItems/selectors';
import { useAirStore } from '~/utils/ReduxUtils';

export const ContentCollectionEditCustomFieldsButton = memo(() => {
  const { isAboveXLScreen } = useBreakpointsContext();

  const store = useAirStore();
  const hasSelectedItems = useSelector(hasSelectedItemsSelector);
  const applyAll = useSelector(contentCollectionApplyAllSelector);

  const [showBoardCollectionGalleryAssetDetailsModal] = useAirModal(ContentCollectionGalleryAssetDetailsModal);

  const form = useSelector(contentCollectionFormSelector);

  if (!form?.fields.some((field) => field.type === 'custom_field') || applyAll) {
    return null;
  }

  if (isAboveXLScreen) {
    return (
      <Button
        appearance="ghost"
        color="gray"
        /**
         * @TODO - Talked w/ design, this is a quick-fix here for content collection. We're going to be redoing disabled states in the next coming weeks.
         */
        className="disabled:bg-transparent disabled:opacity-40"
        data-testid="CONTENT_COLLECTION_EDIT_CUSTOM_FIELDS"
        disabled={!hasSelectedItems}
        size="medium"
        prefix={<PencilIcon className="-mr-1" size="sm" />}
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onClick={() => showBoardCollectionGalleryAssetDetailsModal({ clips: selectedClipsSelector(store.getState()) })}
      >
        Edit fields
      </Button>
    );
  }

  return (
    <IconButton
      appearance="ghost"
      color="gray"
      /**
       * @TODO - Talked w/ design, this is a quick-fix here for content collection. We're going to be redoing disabled states in the next coming weeks.
       */
      className="disabled:bg-transparent disabled:opacity-40"
      data-testid="CONTENT_COLLECTION_EDIT_CUSTOM_FIELDS"
      disabled={!hasSelectedItems}
      adsIcon
      icon={PencilIcon}
      label="Edit"
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onClick={() => showBoardCollectionGalleryAssetDetailsModal({ clips: selectedClipsSelector(store.getState()) })}
      size="medium"
    />
  );
});

ContentCollectionEditCustomFieldsButton.displayName = 'ContentCollectionEditCustomFieldsButton';
